<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <v-col cols="12" md="1">
          <v-icon color="primary">mdi-filter</v-icon
          ><span class="primary--text">
            {{ $t("filter") }}
          </span>
        </v-col>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row>
          <v-col cols="12" sm="5">
            <v-menu
              ref="menu"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="from_date"
                  :label="$t('label.from_date')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="from_date"
                reactive
                no-title
                show-current
                @input="save"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="5">
            <v-menu
              ref="menu"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="to_date"
                  :label="$t('label.to_date')"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="to_date"
                reactive
                no-title
                show-current
                @input="save"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="1" class="align-self-center">
            <v-btn
              @click="handleFilter"
              :disabled="validFitler"
              class="primary"
            >
              <v-icon left>mdi-filter</v-icon>
              Filter
            </v-btn>
          </v-col>
          <v-col v-if="validQuery" cols="12" md="1" class="align-self-center">
            <v-btn @click="clearFilter" class="error">
              <v-icon left>mdi-squeegee</v-icon>
              Clear
            </v-btn>
          </v-col>

          <slot name="otherFilter"></slot>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  name: "DatePickerFilter",
  props: {
    firstDay: {
      type: String,
      default: ""
    },
    lastDay: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      queries: {},
      from_date: "",
      to_date: "",
      menu1: null,
      menu2: null,
      validQuery: false
    };
  },
  methods: {
    handleFilter() {
      if (this.from_date !== "") this.queries["from_date"] = this.from_date;
      if (this.to_date !== "") this.queries["to_date"] = this.to_date;

      this.$router.push({ query: this.queries });
    },
    clearFilter() {
      this.queries = {};
      this.from_date = "";
      this.to_date = "";
      this.$router.push({ query: this.queries });
    },
    save() {
      this.menu1 = false;
      this.menu2 = false;
    }
  },

  watch: {
    $route: {
      handler({ query }) {
        if (query.from_date) {
          this.validQuery = true;
        } else {
          this.validQuery = false;
        }

        if (query.from_date && query.to_date) {
          this.from_date = query.from_date;
          this.to_date = query.to_date;
        } else {
          this.from_date = this.firstDay;
          this.to_date = this.lastDay;
          this.handleFilter();
        }
      },
      immediate: true
    }
  },
  computed: {
    validFitler() {
      if (this.from_date === "" || this.to_date === "") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
